import React from 'react';
import './style.css';
import resImg from "../../assests/Home/Res.jpeg";
import comImg from "../../assests/Home/com.jpeg";
import indImg from "../../assests/Home/ind.jpeg";
import insImg from "../../assests/Home/ins.jpeg";
import civil from "../../assests/Home/civil.jpeg";
import spl from "../../assests/Home/spl.jpeg";
import cus from "../../assests/Home/cus.jpg";

const CircleButtons = () => {
  const buttons = [
    { text: 'Residential', image: resImg },
    { text: 'Commercial', image: comImg },
    { text: 'Industrial', image: indImg },
    { text: 'Government & Institutional', image: insImg },
    { text: 'Civil Engineering', image: civil },
    { text: 'Specialised', image: spl },
  ];

  return (
    <div
      className="sector-section"
    //   style={{
    //     backgroundImage: `url(${cus})`,
    //     backgroundSize: 'cover',
    //     backgroundPosition: 'center',
    //     backgroundRepeat: 'no-repeat',
    //   }}
    >
      <h2 className="section-heading">Building Solutions for Every Sector</h2>

      <div className="button-container">
        {buttons.map((btn, idx) => (
          <div className="circle-wrapper" key={idx}>
            <div
              className="circle-button"
              style={{ backgroundImage: `url(${btn.image})` }}
            >
              <span>{btn.text}</span>
              <div className="half-circle left-half"></div>
              <div className="half-circle right-half"></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CircleButtons;
